// Renders an array of content blocks ({kind:'p'|'h'|'list'|'quote'}) as editorial typography.
export default function ProgramBlocks({ blocks }) {
  return (
    <div className="space-y-6">
      {blocks.map((b, i) => {
        if (b.kind === "h") {
          return (
            <h3
              key={i}
              className="serif text-2xl md:text-3xl text-[#15243D] leading-snug pt-4"
              style={{ fontWeight: 300 }}
            >
              {b.heading}
            </h3>
          );
        }
        if (b.kind === "list") {
          return (
            <ul key={i} className="space-y-2.5 pl-1">
              {b.items.map((it, j) => (
                <li
                  key={j}
                  className="flex items-baseline gap-3 text-base md:text-lg font-light text-[#15243D] leading-relaxed"
                >
                  <span className="text-[#C07865] text-xs">—</span>
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          );
        }
        if (b.kind === "quote") {
          return (
            <blockquote
              key={i}
              className="serif italic text-2xl md:text-3xl text-[#C07865] leading-snug border-l-2 border-[#C07865] pl-6 py-1"
              style={{ fontWeight: 300 }}
            >
              {b.text}
            </blockquote>
          );
        }
        // paragraph (whitespace-pre-line preserves line breaks inside p)
        return (
          <p
            key={i}
            className="text-base md:text-lg font-light leading-relaxed text-[#5A5D63] whitespace-pre-line"
          >
            {b.text}
          </p>
        );
      })}
    </div>
  );
}
